import { render, staticRenderFns } from "./openAlipay.vue?vue&type=template&id=ab7ef0fe&scoped=true&"
import script from "./openAlipay.vue?vue&type=script&lang=js&"
export * from "./openAlipay.vue?vue&type=script&lang=js&"
import style0 from "./openAlipay.vue?vue&type=style&index=0&id=ab7ef0fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7ef0fe",
  null
  
)

export default component.exports